function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { ReactElement, ReactNode, useState } from 'react';
import { SimpleTooltip, SimpleTooltipProps } from '../../components/SimpleTooltip';
export const useSimpleTooltip = props => {
  const [parentElement, setParentRef] = useState(null);
  const {
    label,
    ...otherProps
  } = props;
  let tooltip = null;
  if (parentElement !== null) {
    tooltip = /*#__PURE__*/React.createElement(SimpleTooltip, _extends({}, otherProps, {
      parentElement: parentElement
    }), label);
  }
  return [tooltip, setParentRef];
};